import {
  Paper,
  Typography,
  Button,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import {  MouseEvent } from "react";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import {insuranceClaimDetailsReport,insuranceClaimDetailsReportPdf,insuranceClaimDetailsReportExcel } from "../services";

function InsuranceClaimDetailsReport() {
  const { control, reset, getValues } = useForm();
  const {
    mutate: getTableData,
    data: tableData,
    isLoading: tableDataLoading,
    reset: resetMutation,
  } = useMutation(insuranceClaimDetailsReport);

  const { mutate: getPdfFile, isLoading: pdfLoading } =
    useRepotFile({
      apiFunction: insuranceClaimDetailsReportPdf,
      responseFileKey:"file",
    });
    const { mutate: getExcelFile, isLoading: excelLoading } =
      useRepotFile({
        apiFunction: insuranceClaimDetailsReportExcel,
        fileType: "xlsx",
        // responseFileKey: "file",
      });

  const onChange = () => {
    const data = getValues();
    if (data?.fromDate && data?.toDate) {
      getTableData(data as { fromDate: string; toDate: string });
    }else{
      resetMutation()
    }
  };

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: "",
    });
    resetMutation();
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getPdfFile({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
    else {
      getExcelFile({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
           Insurance Claim Detail Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "TO Date is required", onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
            type="submit"
            disabled={tableDataLoading}
            endIcon={tableDataLoading && <CircularProgress size={18} />}
          >
            search
          </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              pdfLoading || !Boolean(tableData?.response?.length)
            }
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          <Button
          disabled={excelLoading || !Boolean(tableData?.response?.length)}
          endIcon={excelLoading && <CircularProgress size={18} />}
          data-filetype="excel"
          onClick={getFiles}
        >
          excel
        </Button>
        </div>
        <TableComponent
          loading={tableDataLoading}
          data={tableData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
}

export default InsuranceClaimDetailsReport;

const heading = [
  { heading: "Patient Name", key: "patientName" },
  { heading: "Insurance Name", key: "insuranceName" },
  { heading: "Created date", key: "createdByDate",date:"DD-MM-YYYY hh:mm A",format:"YYYY-MM-DDTHH:mm:ss" },
  { heading: "Submission type", key: "submissionType" },
  { heading: "Submission status", key: "submissionStatus" },
  { heading: "Insurance amount", key: "insShare" },
  { heading: "Received amount", key: "receivedAmt" },
];

